export function round(number, places) {
    return +(Math.round(number + "e+" + places) + "e-" + places);
}

export function net(gross) {
    return round(gross / 1.23, 2);
}

export function vat(gross) {
    return round(gross - net(gross), 2);
}

export function money(value) {
    return Number.parseFloat(value)
        .toFixed(2)
        .toString()
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' zł';
}

export function money_short(value) {
    return value.replace(',00', '');
}
